import blankAction from '../assets/images/bbBlankAction.png'

export default function getRoundOccupiedSlotEntries(
  slots,
  round,
  { blockedSlot = null, maxSlot = null } = {},
) {
  const actions = Array.isArray(slots?.actions) ? slots.actions : []
  const markers = Array.isArray(slots?.markers) ? slots.markers : []
  const blockedSlotNumber = Number(blockedSlot)
  const hasBlockedSlot = Number.isFinite(blockedSlotNumber) && blockedSlotNumber > 0
  const maxSlotNumber = Number(maxSlot)
  const hasMaxSlot = Number.isFinite(maxSlotNumber) && maxSlotNumber > 0

  const inRange = (slotNumber) => {
    if (!Number.isFinite(slotNumber)) {
      return false
    }

    if (hasBlockedSlot && slotNumber === blockedSlotNumber) {
      return false
    }

    if (hasMaxSlot && slotNumber > maxSlotNumber) {
      return false
    }

    return true
  }

  const roundActions = actions
    .filter(
      (action) =>
        action?.round === round &&
        inRange(action?.number) &&
        action?.action_name !== 'pending' &&
        action?.action_name !== 'blank',
    )
    .map((action) => ({
      number: action.number,
      image: action.action_image || blankAction,
      kind: 'action',
      name: action.action_name,
    }))

  const roundMarkers = markers
    .filter(
      (marker) =>
        marker?.round === round &&
        inRange(marker?.number) &&
        marker?.marker_name !== 'pending' &&
        marker?.marker_name !== 'blank',
    )
    .map((marker) => ({
      number: marker.number,
      image: marker.marker_image || blankAction,
      kind: 'marker',
      name: marker.marker_name,
    }))

  return [...roundActions, ...roundMarkers].sort((left, right) => right.number - left.number)
}
